import { useContext } from 'react';
import { AccordionContext } from '../../context';
export var useAccordionContext = function useAccordionContext() {
  return useContext(AccordionContext);
};